import { isObject, deepMerge } from "@/utils/lodash";
import {
  RequsetConfigInterface,
  NativeResponseInterface,
  NativeRequestInterface
} from "../types/axios_type";
import {
  content_type_base64_body,
  createCancleToken,
  transformParamsToString
} from "@/api/utils/api_helpers";

/**
 * 秒转毫秒
 * @param second
 */
export const transform_millisecond_to_second = (millisecond: number) => {
  return millisecond / 1000;
};

/**
 * path+baseURL
 * @param path
 * @param baseURL
 */
export const combine_path_and_baseURL = (
  path: string,
  baseURL: string
): string => {
  // user URL api:
  return new URL(path, baseURL).href;
};

/**
 * 校验返回的状态码
 * @param native_response
 */
export const validate_response = (native_response: NativeResponseInterface) => {
  console.log("native_response:", native_response);
  const { status_code } = native_response;
  // TODO config from validateStatus fn:
  return status_code >= 200 && status_code < 300;
};

/**
 * 配置merge
 * @param config1
 * @param config2
 */
export const merge_config = (config1: any, config2: any) => {
  // merge multiple config
  const new_config: any = {
    ...config1,
    ...config2
  };

  const merge_deep_props_keys = ["headers", "auth"];

  merge_deep_props_keys.forEach((prop: string) => {
    if (isObject(config2[prop])) {
      new_config[prop] = deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== "undefined") {
      new_config[prop] = config2[prop];
    } else if (isObject(config1[prop])) {
      new_config[prop] = deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== "undefined") {
      new_config[prop] = config1[prop];
    }
  });

  return new_config;
};

export const transform_config_to_native_req_instance = (
  config: RequsetConfigInterface
): NativeRequestInterface => {
  // native requeset的实例参数
  const native_request_instance: any = {};
  // 将包装处理后的config解析成native_request的请求:
  const {
    url,
    baseURL,
    headers,
    params,
    timeout,
    method,
    data,
    cache_name,
    cache_directory,
    cancel_token
  } = config;

  // 处理path,baseURL,querystring
  if (params) {
    // 存在params:
    const query_string = `?${transformParamsToString(params)}`;
    const base_url = combine_path_and_baseURL(url, baseURL);
    native_request_instance.url = combine_path_and_baseURL(
      query_string,
      base_url
    );
  } else {
    native_request_instance.url = combine_path_and_baseURL(url, baseURL);
  }

  // 处理原生需要的headers:
  native_request_instance.headers = headers;

  // 处理原生需要的timeout,原生单位是s
  native_request_instance.timeout = transform_millisecond_to_second(timeout);

  // 处理原生需要的method
  native_request_instance.method = method;

  // 处理原生需要的body
  if (data && method === "POST") {
    // 存在data，需要base64String
    const content_type: any = headers["content-type"];
    native_request_instance.body = content_type_base64_body(content_type, data);
  }

  // 下载文件名
  if (cache_name) {
    native_request_instance.cache_name = cache_name;
  }

  // 下载文件目录
  if (cache_directory) {
    native_request_instance.cache_directory = cache_directory;
  }

  // cancel_token,生成string
  if (cancel_token) {
    //
    native_request_instance.cancel_token = createCancleToken();
  }

  return native_request_instance;
};
